function deriveNodeNavigationDetails(node) {
  /**
   * When deriving navigation details, if a slug exists (for questions or intersitials) then attempt to use
   * that as the node identifier. If not, fallback to an ID.
   *
   * The `pathSlug` can change node over node since we concatenate the slug as you move in and out of the
   * different depths of fragments.
   */
  var nodeSlug;

  switch (node.viewModel.__typename) {
    case 'InterstitialPathNodeFlowViewModel':
    case 'QuestionsPathNodeFlowViewModel':
      if (node.viewModel.slug) {
        nodeSlug = node.viewModel.slug;
      }

      break;
  }

  return {
    nodeId: node.viewModel.id,
    pathSlug: node.pathGraphSlug,
    nodeSlug: nodeSlug
  };
}

export default deriveNodeNavigationDetails;
//# sourceMappingURL=deriveNodeNavigationDetails.js.map
